import { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CUSTOM_ICON_BUTTON_VARIANT, CustomIconButton } from 'src/components/CustomIconButton';
import { CUSTOM_TOOLTIP_SIZE, CustomTooltip } from 'src/components/CustomTooltip';

import { useStyles } from './useStyles';

export const ToolbarButton = forwardRef(
  ({ className, tooltip, selected, disabled, children, ...restProps }, ref) => {
    const styles = useStyles();

    return (
      <CustomTooltip
        title={tooltip || ''}
        size={CUSTOM_TOOLTIP_SIZE.small}
        arrow
      >
        <span ref={ref}>
          <CustomIconButton
            className={cx(styles.root, className, { [styles.selected]: selected })}
            variant={CUSTOM_ICON_BUTTON_VARIANT.silver}
            disabled={disabled}
            {...restProps}
          >
            {children}
          </CustomIconButton>
        </span>
      </CustomTooltip>
    );
  }
);

ToolbarButton.propTypes = {
  className: PropTypes.string,
  tooltip: PropTypes.string,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

ToolbarButton.defaultProps = {
  className: '',
  tooltip: '',
  selected: false,
  disabled: false,
};
